module.exports = {
	"ha": "iha",
	"id": 5.7,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by HSDA, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": true,
							"format": "38"
						}
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": true,
							"format": "26"
						}
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": true,
							"format": "24"
						}
					},
					{
						"y": 55.00000000000001,
						"dataLabels": {
							"enabled": true,
							"format": "22"
						}
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": true,
							"format": "15"
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "66"
						}
					},
					{
						"y": 84.84848484848484,
						"dataLabels": {
							"enabled": true,
							"format": "56"
						}
					},
					{
						"y": 80.3030303030303,
						"dataLabels": {
							"enabled": true,
							"format": "53"
						}
					},
					{
						"y": 74.24242424242425,
						"dataLabels": {
							"enabled": true,
							"format": "49"
						}
					},
					{
						"y": 56.060606060606055,
						"dataLabels": {
							"enabled": true,
							"format": "37"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.96511627906976,
						"dataLabels": {
							"enabled": true,
							"format": "337"
						}
					},
					{
						"y": 82.26744186046511,
						"dataLabels": {
							"enabled": true,
							"format": "283"
						}
					},
					{
						"y": 78.19767441860465,
						"dataLabels": {
							"enabled": true,
							"format": "269"
						}
					},
					{
						"y": 74.70930232558139,
						"dataLabels": {
							"enabled": true,
							"format": "257"
						}
					},
					{
						"y": 54.360465116279066,
						"dataLabels": {
							"enabled": true,
							"format": "187"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.3917525773196,
						"dataLabels": {
							"enabled": true,
							"format": "187"
						}
					},
					{
						"y": 76.80412371134021,
						"dataLabels": {
							"enabled": true,
							"format": "149"
						}
					},
					{
						"y": 71.1340206185567,
						"dataLabels": {
							"enabled": true,
							"format": "138"
						}
					},
					{
						"y": 67.0103092783505,
						"dataLabels": {
							"enabled": true,
							"format": "130"
						}
					},
					{
						"y": 52.57731958762887,
						"dataLabels": {
							"enabled": true,
							"format": "102"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.57894736842105,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.818181818181824,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.151515151515149,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.35714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.547169811320753,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.489795918367353,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.034883720930236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.02373887240356,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.946996466431097,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.460966542750933,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.237354085603116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.6082474226804107,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.320855614973265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.38255033557047,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.797101449275366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.53846153846154,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "East Kootenay<br>n=40"
			},
			{
				"x": 9,
				"text": "Kootenay Boundary<br>n=66"
			},
			{
				"x": 15,
				"text": "Okanagan<br>n=344"
			},
			{
				"x": 21,
				"text": "Thompson Cariboo Shuswap<br>n=194"
			}
		],
		"dataTable": {
			"East Kootenay": [
				40,
				38,
				26,
				24,
				22,
				15
			],
			"Kootenay Boundary": [
				66,
				66,
				56,
				53,
				49,
				37
			],
			"Okanagan": [
				344,
				337,
				283,
				269,
				257,
				187
			],
			"Thompson Cariboo Shuswap": [
				194,
				187,
				149,
				138,
				130,
				102
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_7.json
// module id = 236
// module chunks = 0